import { authReducer } from '../../authentication/reducers/AuthReducer';
import authenticationSaga from '../../authentication/sagas/AuthSaga';
import { basketReducer } from '../../basket/reducers/BasketReducer';
import basketSaga from '../../basket/sagas/BasketSagas';
const loadGiftVoucherDynamicModule = () => ({
    id: 'GiftVoucher',
    reducerMap: {
        authentication: authReducer,
        basket: basketReducer,
    },
    sagas: [authenticationSaga, basketSaga],
});
export default loadGiftVoucherDynamicModule;
